// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { insertBlockPlugin } from '@atlaskit/editor-plugin-insert-block';
export type {
	InsertBlockPlugin,
	InsertBlockOptions,
	InsertBlockPluginOptions,
	InsertBlockPluginDependencies,
	InsertBlockPluginState,
	ToolbarInsertBlockButtonsConfig,
} from '@atlaskit/editor-plugin-insert-block';
